export default "__VITE_ASSET__6fa109ea__"